import { ApiClient } from '../apiClient';
import { CarouselBanner } from '../../types/banner';

export class BannerService {
  constructor(private apiClient: ApiClient) {}

  /**
   * Active homepage carousel banners, sorted by order (cached server-side).
   */
  async getActive(): Promise<CarouselBanner[]> {
    return this.apiClient.get<CarouselBanner[]>('/carousel-banners');
  }

  /**
   * Register a banner click (per-IP deduped server-side, 5-minute window).
   */
  async registerClick(id: string): Promise<void> {
    return this.apiClient.post<void>(`/carousel-banners/${id}/click`);
  }
}
